module.exports = __webpack_public_path__ + "static/media/July-green.b2dbe744.svg";